import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Button, Col, Row } from 'react-bootstrap';
import { SiteStatusName } from 'constants/SiteCreator';
import { useLocation, useNavigate } from 'react-router-dom';
import SiteCreatorTable from './SiteCreatorTable';
import RouterPaths from '../constants/RouterPaths';
import SiteCreatorSearch from './search/SiteCreatorSearch';
import PageBreadcrumb from '../common/components/layout/PageBreadcrumb';
import { setQueryString, useQueryString } from '../common/helpers/queryString';
import { searchSite } from './SiteCreatorActions';

function SiteCreatorPage() {
  const query = useQueryString();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const items = useSelector((state) => state.siteCreator.get('items'));
  const totalItems = useSelector((state) => state.siteCreator.get('totalItems'));

  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
  });

  useEffect(() => {
    dispatch(searchSite(searchParams));
  }, [dispatch, searchParams]);

  const handleSearch = (values, { setSubmitting }) => {
    const { title, status } = values;
    let isActive = '';
    if (status) {
      isActive = status.label === SiteStatusName.ACTIVE;
    }
    setSearchParams((prevState) => ({ ...prevState, title, isActive, offset: 0 }));
    setSubmitting(false);
  };

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({ ...prevState, offset: value }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'span', text: 'Static Pages' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Static Pages" />
      <Row>
        <Col xs="12" className="mb-3">
          <Button
            className="float-end rounded-pill btn-primary"
            onClick={() => navigate(RouterPaths.CREATE_SITE)}
          >
            Add Site
          </Button>
        </Col>
      </Row>
      <Row>
        <SiteCreatorSearch onSearch={handleSearch} />
      </Row>
      <Row>
        <SiteCreatorTable
          data={{ items, total: totalItems }}
          offset={searchParams.offset}
          changeOffset={changeOffset}
        />
      </Row>
    </Container>
  );
}

export default SiteCreatorPage;
